import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Group = makeShortcode("Group");
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Called when we begin to fetch metadata forthe current `}<inlineCode parentName="p">{`rawData`}</inlineCode>{`. Changing `}<inlineCode parentName="p">{`rawData`}</inlineCode>{` triggers this callback.
Some time after this is called, `}<inlineCode parentName="p">{`primerRawDataManager(_:didReceiveMetadata:forState:)`}</inlineCode>{` will be called with the relevant metadata for the state.`}</p>
    <p>{`Use this method to indicate to the user that metadata is being fetched; for example, by showing a loading spinner or other UI until the metadata has been returned.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`func primerRawDataManager(_ rawDataManager: PrimerHeadlessUniversalCheckout.RawDataManager,
                          willFetchMetadataForState state: PrimerValidationState)
`}</code></pre>
    <h4>{`Parameters`}</h4>
    <Group mdxType="Group">
	<Item title='rawDataManager' subtitle='PrimerHeadlessUniversalCheckout.RawDataManager' mdxType="Item">
		The instance of the raw data manager calling this delegate method.
	</Item>
      <Item title='state' subtitle='PrimerValidationState' mdxType="Item">
        <p>{`An object containing the state that triggered the metadata fetch. For example, for
card number entry, this will be an instance of `}<inlineCode parentName="p">{`PrimerCardNumberEntryState`}</inlineCode></p>
        <Group summary='Implementations' open mdxType="Group">
          <Item title='class PrimerCardNumberEntryState' mdxType="Item">
            <p>{`Used when `}<inlineCode parentName="p">{`rawData`}</inlineCode>{` is set to `}<inlineCode parentName="p">{`PrimerCardData`}</inlineCode></p>
            <Group summary='Properties' open mdxType="Group">
              <Item title="cardNumber" subtitle="String" label="Required" mdxType="Item">
                <p>{`The card number set on `}<inlineCode parentName="p">{`rawData`}</inlineCode>{` that triggered the metadata fetch`}</p>
              </Item>
            </Group>
          </Item>
        </Group>
      </Item>
    </Group>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      